import { useState, useEffect } from "react";
import { formatUSPhone, getUSPhoneDigits } from "../utils/phoneFormatter";

type PhoneNumberInputProps = {
    name: string;
    value: string;
    setValue: (value: string) => void;
    fontSize?: string;
    paddingBlock?: string;
    required?: boolean;
    readOnly?: boolean;
    disabeld?: boolean;
    tabIndex?: number
}

export const PhoneNumberInput = ({
    name,
    value,
    setValue,
    fontSize = "12px",
    paddingBlock,
    required = false,
    readOnly,
    disabeld,
    tabIndex
}: PhoneNumberInputProps) => {
    const [isFocus, setIsFocus] = useState<boolean>(false);
    const [isPhoneValid, setIsPhoneValid] = useState(true);

    const handleChange = (inputValue: string) => {
        const digits = getUSPhoneDigits(inputValue);
        setValue(digits);
        if (digits.length === 0) {
            setIsPhoneValid(true);
        } else {
            setIsPhoneValid(digits.length === 10);
        }
    };

    useEffect(() => {
        if (value.length === 0) {
            setIsPhoneValid(true);
        } else {
            setIsPhoneValid(value.length === 10);
        }
    }, [value]);

    return (
        <>
            <input
                type="text"
                tabIndex={tabIndex}
                readOnly={readOnly}
                placeholder="Mobile Number"
                pattern="\(\d{3}\) \d{3}-\d{4}"
                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                title="Please enter a 10-digit phone number."
                name={name}
                value={formatUSPhone(value)}
                onChange={(e) => {
                    setIsFocus(true);
                    handleChange(e.target.value);
                }}
                onBlur={() => setIsFocus(false)}
                required={required}
            />

            {
                (!isPhoneValid && isFocus) && (
                    <div className="flex items-center gap-1 mt-2 text-xs text-red-500 ml-1">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 26 26"
                            strokeWidth={2}
                            stroke="currentColor"
                            className="w-4 h-4 text-red-500"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 9v3m0 3h.01m-9 0a9 9 0 1118 0 9 9 0 01-18 0z"
                            />
                        </svg>

                        <span>Please enter a valid 10-digit phone number</span>
                    </div>
                )
            }
        </>
    );
};

